import React, { FC } from 'react';

import PropTypes from 'prop-types';

import { BasicButton } from '@adsk/alloy-react-button';
import { RenderIconType } from '@adsk/alloy-react-icon';
import { useTheme } from '@adsk/alloy-react-styles';

import { TABLE_SIZES } from '../../consts';
import { TableSize } from '../../types';

type DensityOptionProps = {
  setSize: (size: TableSize) => void;
  size: TableSize;
  renderIcon: RenderIconType;
  currentSize: TableSize;
};

const DensityOption: FC<DensityOptionProps> = ({
  setSize,
  size,
  renderIcon,
  currentSize,
}) => {
  const theme = useTheme();
  const densityOption =
    theme.tokens?.component?.table?.configuration?.densityOption;
  const isSelected = size === currentSize;

  return (
    <BasicButton
      onClick={() => setSize(size)}
      style={[
        densityOption?._,
        densityOption?.selected?.[isSelected ? 'true' : 'false'],
      ]}
    >
      {renderIcon({ size: 22 })}
    </BasicButton>
  );
};

DensityOption.propTypes = {
  setSize: PropTypes.func.isRequired,
  size: PropTypes.oneOf<TableSize>(Object.values(TABLE_SIZES)).isRequired,
  currentSize: PropTypes.oneOf<TableSize>(Object.values(TABLE_SIZES))
    .isRequired,
};

export default DensityOption;
